import { FormattedMessage } from "react-intl";
import { Tooltip } from "@/components/common/Tooltip";
import type { PowerQuizState } from "./use-power-quiz-status";

export function PowerQuizStatus({ status }: { status: PowerQuizState | null }) {
  if (!status) return null;
  return (
    <Tooltip className="text-smycles-meta text-ink-muted" content={
      <>
        {status.complete ? (
          <FormattedMessage id="grow.powerDetail.quiz.complete" defaultMessage="Power Quiz completed." />
        ) : (
          <FormattedMessage id="grow.powerDetail.quiz.incomplete" defaultMessage="Power Quiz not completed." />
        )}{" "}
        {status.included ? (
          <FormattedMessage id="grow.powerDetail.quiz.includedHint" defaultMessage="Your Power Quiz answers for this Power are included in the self-assessment score." />
        ) : (
          <FormattedMessage id="grow.powerDetail.quiz.notIncludedHint" defaultMessage="There are no scored Power Quiz answers for this Power yet." />
        )}
      </>
    }>
      <span id="grow-power-quiz-status">
        {status.complete ? (
          <FormattedMessage id="grow.powerDetail.quiz.done" defaultMessage="Power Quiz done" />
        ) : status.started ? (
          <FormattedMessage id="grow.powerDetail.quiz.inProgress" defaultMessage="Power Quiz in progress" />
        ) : (
          <FormattedMessage id="grow.powerDetail.quiz.missing" defaultMessage="Power Quiz missing" />
        )}
      </span>
    </Tooltip>
  );
}
